import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => (location.pathname === path ? "active" : "");

 useEffect(() => {
  if (menuOpen) {
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
  } else {
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.width = "";
  }

  return () => {
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.width = "";
  };
}, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  // ✅ Anchor handler (MAIN FIX)
  const handleAnchorClick = (e, section) => {
    closeMenu();

    if (location.pathname !== "/") {
      e.preventDefault(); // stop default jump
      navigate("/");

      setTimeout(() => {
        document.getElementById(section)?.scrollIntoView({
          behavior: "smooth",
        });
      }, 150);
    }
    // if already "/", anchor works automatically
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark header-nav">
      <div className="container-fluid">

        {/* LOGO */}
        <Link className="navbar-brand logo" to="/" onClick={closeMenu}>
          <img src="/images/logo.png" alt="logo" />
        </Link>

        {/* RIGHT SIDE */}
        <div className="d-flex align-items-center ms-auto order-lg-last">

          <Link
            to="/booking"
            className="btn btn-schedule me-3"
            onClick={closeMenu}
          >
            Schedule A Demo
          </Link>

          {/* MOBILE TOGGLER */}
          <button
            className="navbar-toggler d-lg-none"
            onClick={() => setMenuOpen(true)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>

        {/* DESKTOP MENU */}
        <div className="collapse navbar-collapse d-none d-lg-flex">
          <ul className="navbar-nav mx-auto nav-links">

            <li className="nav-item">
              <a
                href="#home"
                className={`nav-link ${isActive("/")}`}
                onClick={(e) => handleAnchorClick(e, "home")}
              >
                Home <i className="fa-solid fa-plus"></i>
              </a>
            </li>

            <li className="nav-item">
              <a
                href="#features"
                className="nav-link"
                onClick={(e) => handleAnchorClick(e, "features")}
              >
                Key Features <i className="fa-solid fa-plus"></i>
              </a>
            </li>

            <li className="nav-item">
              <a
                href="#how-it-works"
                className="nav-link"
                onClick={(e) => handleAnchorClick(e, "how-it-works")}
              >
                How it works <i className="fa-solid fa-plus"></i>
              </a>
            </li>

            <li className="nav-item">
              <a
                href="#reviews"
                className="nav-link"
                onClick={(e) => handleAnchorClick(e, "reviews")}
              >
                Reviews <i className="fa-solid fa-plus"></i>
              </a>
            </li>

          </ul>
        </div>

        {/* MOBILE MENU */}
        <div className={`mobile-menu d-lg-none ${menuOpen ? "open" : ""}`}>

          <div className="menu-close" onClick={closeMenu}>
            <i className="fa-solid fa-xmark"></i>
          </div>

          <ul className="navbar-nav">

            <li>
              <a href="#home" onClick={(e) => handleAnchorClick(e, "home")} className="nav-link">
                Home <i className="fa-solid fa-plus"></i>
              </a>
            </li>

            <li>
              <a href="#features" onClick={(e) => handleAnchorClick(e, "features")} className="nav-link">
                Features <i className="fa-solid fa-plus"></i>
              </a>
            </li>

            <li>
              <a href="#how-it-works" onClick={(e) => handleAnchorClick(e, "how-it-works")} className="nav-link">
                How it works <i className="fa-solid fa-plus"></i>
              </a>
            </li>

            <li>
              <a href="#reviews" onClick={(e) => handleAnchorClick(e, "reviews")} className="nav-link">
                Reviews <i className="fa-solid fa-plus"></i>
              </a>
            </li>

          </ul>
        </div>

        {/* BACKDROP */}
        {menuOpen && (
          <div className="menu-overlay d-lg-none" onClick={closeMenu} />
        )}

      </div>
    </nav>
  );
};

export default Header;